import { isWiseAlias } from './aliasFilter';
import { hasDuration } from './deliveryEstimationService';
import translate from './translate';

function isTwPowered(isPartner, alias) {
  return isPartner || isWiseAlias(alias);
}

function getScenarioKey(deliveryEstimation, isPartner, alias, isTravelMoney = false) {
  if (!deliveryEstimation.providerGivesEstimate) {
    return 'provider-does-not-give-estimate';
  }
  if (!hasDuration(deliveryEstimation)) {
    return 'not-yet-collected';
  }
  if (isTravelMoney) {
    if (isTwPowered(false, alias)) {
      return 'tw-travel-money';
    }
    return 'non-tw-travel-money';
  }
  if (isTwPowered(isPartner, alias)) {
    return 'tw-powered';
  }
  return 'non-tw-powered';
}

// eslint-disable-next-line import/prefer-default-export
export const getCitationCopy = (deliveryEstimation, isPartner, alias, lang, isTravelMoney) => {
  const scenarioKey = getScenarioKey(deliveryEstimation, isPartner, alias, isTravelMoney);
  const baseTranslationKey = `delivery-estimation.${scenarioKey}.citation`;
  return {
    title: translate(`${baseTranslationKey}.title`, lang),
    body: translate(`${baseTranslationKey}.body`, lang),
  };
};
